module.exports = __webpack_public_path__ + "img/icn-apple.10e39d44.svg";